import { GeneratorCountryZoneCountryModel, GeneratorCountryZoneModel } from '@/Models';
import { RootState } from '@/Redux/RootReducer';
import { Pair } from '@/Types';

export function addZone(countryZones: GeneratorCountryZoneCountryModel[], model: GeneratorCountryZoneModel) {
  if (isTopLevel(model)) {
    addCountryZone(countryZones, model);
  } else {
    const countryZone = countryZoneUtils.countryZoneById(model.parentId, countryZones);
    if (countryZone) {
      countryZone.zoneLevels.push(model);
    }
  }
}

export function updateZone(
  countryZones: GeneratorCountryZoneCountryModel[],
  model: GeneratorCountryZoneModel,
  selectedUuid = '',
) {
  if (isTopLevel(model)) {
    updateCountryZone(countryZones, model, selectedUuid);
  } else {
    const countryZone = countryZoneUtils.countryZoneById(model.parentId, countryZones);
    if (countryZone) {
      countryZone.zoneLevels = countryZone.zoneLevels.map((x) => {
        if (selectedUuid !== '') {
          return x.uuid == selectedUuid ? model : x;
        }
        return x.id === model.id ? model : x;
      });
    }
  }
}

export function deleteZone(countryZones: GeneratorCountryZoneCountryModel[], modelId: string | number) {
  deleteCountryZone(countryZones, modelId);
  deleteZoneLevel(countryZones, modelId);
}

export function fillLocalization(x: GeneratorCountryZoneCountryModel, state: RootState): any {
  x.countryName = enumToString(x.country, state.logisticWarehouseData.countryCodes);
}

export function isTopLevel(x: GeneratorCountryZoneModel): boolean {
  return !x.parentId || x.parentId === '';
}

function enumToString<TKey>(enumKey: TKey, locs: Pair<TKey>[]): any {
  return enumKey ? locs.find((y) => y.key == enumKey)?.value || enumKey : enumKey;
}

function countryZoneById(countryZoneId: string | number, zones: GeneratorCountryZoneCountryModel[]) {
  for (const zone of zones) {
    for (const logistic of zone.logistics) {
      for (const countryZone of logistic.countryZones) {
        if (countryZone.id == countryZoneId) {
          return countryZone;
        }
      }
    }
  }

  return null;
}

function addCountryZone(countryZones: GeneratorCountryZoneCountryModel[], model: GeneratorCountryZoneModel) {
  const countryZone = countryZones.find((x) => x.country === model.countryCode);
  if (countryZone) {
    let logistic = countryZone.logistics.find((x) => x.logisticId == model.logisticTypeId);
    if (logistic) {
      logistic.countryZones.push(model);
    } else {
      logistic = {
        country: model.countryCode,
        logisticId: Number(model.logisticTypeId),
        countryZones: [model],
      };
      countryZone.logistics.push(logistic);
    }
  }
}

function updateCountryZone(
  countryZones: GeneratorCountryZoneCountryModel[],
  model: GeneratorCountryZoneModel,
  selectedUuid = '',
) {
  const countryZone = countryZones.find((x) => x.country === model.countryCode);
  if (countryZone) {
    const logistic = countryZone.logistics.find((x) => x.logisticId == model.logisticTypeId);
    if (logistic) {
      logistic.countryZones = logistic.countryZones.map((x) => {
        if (selectedUuid !== '') {
          return x.uuid == selectedUuid ? model : x;
        }
        return x.id === model.id ? model : x;
      });
    }
  }
}

function deleteCountryZone(countryZones: GeneratorCountryZoneCountryModel[], id: string | number) {
  countryZones.forEach((x) => {
    x.logistics.forEach((y) => (y.countryZones = y.countryZones.filter((z) => z.id !== id)));
    x.logistics = x.logistics.filter((y) => y.countryZones.length !== 0);
  });
}

function deleteZoneLevel(zones: GeneratorCountryZoneCountryModel[], id: string | number) {
  zones.forEach((x) => {
    x.logistics.forEach((y) =>
      y.countryZones.forEach((z) => {
        z.zoneLevels = z.zoneLevels.filter((level) => level.id != id);
      }),
    );
  });
}

export const countryZoneUtils = {
  addZone,
  updateZone,
  deleteZone,
  fillLocalization,
  countryZoneById,
  isTopLevel,
};
